/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Common_Page_CountInputs */

const en_common_page_count = /** @type {(inputs: Common_Page_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} page`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} pages`);
	return /** @type {LocalizedString} */ ("common_page_count");
};

const es_common_page_count = /** @type {(inputs: Common_Page_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} página`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} páginas`);
	return /** @type {LocalizedString} */ ("common_page_count");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} page" |
* | "other" | "{count} pages" |
*
* @param {Common_Page_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_page_count = /** @type {((inputs: Common_Page_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Page_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_page_count(inputs)
	return en_common_page_count(inputs)
});